import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Badge, Dropdown } from 'react-bootstrap';

// import images
import verticalicon from '../.././../images/verticalicon.svg';
import ToastMessage from '../../ToastMessage';
import { API_BASE_URL, getBearerToken } from '../../../functions';
import axios from 'axios';
import AddSector from '../../Modals/AddSector';

const SectorTRLoop = (props) => {
    const [toastMessage, setToastMessage] = useState(null);
    const [show, setShow] = useState(false)


    const handalDelet = (e, id) => {
        axios.get(`${API_BASE_URL}/deletesector/${e}`, {
            headers: {
                'Authorization': `Bearer ${getBearerToken()}`
            }
        }).then(response => {
            // Handle the response data
            setToastMessage({ type: 'success', message: 'Sector Deleted successfully!', show: 'show' });
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        }).catch(error => {
            // Handle errors
            console.error(error);
        });

    };

    const handalEdit = (e, id) => {
        setShow(true)
    };
    // console.log(props);

    return (
        <>
            {toastMessage && <ToastMessage type={toastMessage.type} message={toastMessage.message} show={toastMessage.show} />}

            <tr>
                <td>
                    <Link to={'#'} className={'d-flex align-items-center text-decoration-none'}>
                        {/* <div className='AllPhoto'><img className={'img-fluid'} src={props.usericon} alt={'icon'} /></div> */}
                        <h5 className={'ms-3 fontsize14 fontweight600 blacktext'}>{props.sector_name}</h5>
                    </Link>
                </td>
                <td>{props.from_sector}</td>
                <td>{props.from_city}</td>
                <td>{props.to_sector}</td>
                <td>{props.to_city}</td>
                <td><Badge bg={''} className={`p-2 py-1 ${props.status == 1 ? 'successcolorbg whitetext' : 'errorlighterbg redtext'}`}>{props.status == 1 ? "Active" : "Inactive"}</Badge></td>
                <td>
                    <Dropdown className={''} align={'end'} autoClose="outside">
                        <Dropdown.Toggle className={''} variant={''} id="dropdown-autoclose-outside"><img className={'img-fluid'} src={verticalicon} alt={'icon'} /></Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item className={'dropdown-item'} onClick={(e) => handalEdit(props?.id)}>Edit</Dropdown.Item>
                            <Dropdown.Item className={'dropdown-item'} onClick={(e) => handalDelet(props?.id)}>Delete</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </td>
            </tr>
            {show &&
                <AddSector show={show} setShow={setShow} editData={props} />
            }
        </>
    )
}

export default SectorTRLoop;